export const module6InitialState = {
  module6: {
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    coins: 0,
    keys: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      FishSchoolYellow: false,
      FishSchoolGreen: false,
      Dolphin: false,
      Shark: false,
      SeaweedGreen: false,
      SeaweedBrown: false,
      ClamBlue: false,
      ClamPink: false,
      CoralRed: false,
      CoralBlue: false,
      SunkenShipGreen: false,
      SunkenShip: false,
      CoralGreen: false,
      CoralPurple: false,
      MermaidBlue: false,
      MermaidRed: false,
      SandCastle: false,
      Treasure: false,
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
    },
  },
};

export const Module6Reducer = (state = module6InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE6_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        FishSchoolYellow: false,
        FishSchoolGreen: false,
        Dolphin: false,
        Shark: false,
        SeaweedGreen: false,
        SeaweedBrown: false,
        ClamBlue: false,
        ClamPink: false,
        CoralRed: false,
        CoralBlue: false,
        SunkenShipGreen: false,
        SunkenShip: false,
        CoralGreen: false,
        CoralPurple: false,
        MermaidBlue: false,
        MermaidRed: false,
        SandCastle: false,
        Treasure: false,
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]] = true;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[], "tokens_earned":0}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
      };

      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"SurfBoardRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"FloatationInnerTube\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SeashellsRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"CrabWearMustash\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module6: {
          ...state.module6,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
          coins: JSON.parse(tempObj)?.tokens_earned,
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module6InitialState,
      };
    }
    case 'MODULE6_SET_DAY': {
      return {
        ...state,
        module6: {
          ...state.module6,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE6_SET_GameDetials': {
      return {
        ...state,
        module6: {
          ...state.module6,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE6_SET_stepCompleted': {
      return {
        ...state,
        module6: {
          ...state.module6,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE6_SET_dayCompleted': {
      return {
        ...state,
        module6: {
          ...state.module6,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE6_SET_CAMERAOPEN': {
      return {
        ...state,
        module6: {
          ...state.module6,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE6_SET_KEY': {
      return {
        ...state,
        module6: {
          ...state.module6,
          keys: action.payload,
        },
      };
    }

    case 'MODULE6_SET_COIN': {
      return {
        ...state,
        module6: {
          ...state.module6,
          coins: action.payload,
        },
      };
    }

    case 'MODULE6_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module6: {
          ...state.module6,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE6_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module6: {
          ...state.module6,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE6_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module6: {
          ...state.module6,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE6_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module6: {
          ...state.module6,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE6_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module6: {
          ...state.module6,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE6_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module6: {
          ...state.module6,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE6_SET_REWARD11': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            FishSchoolYellow: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD12': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            FishSchoolGreen: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD21': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            Dolphin: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD22': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            Shark: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD31': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            SeaweedGreen: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD32': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            SeaweedBrown: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD41': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            ClamBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD42': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            ClamPink: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD51': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            CoralRed: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD52': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            CoralBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD61': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            SunkenShipGreen: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD62': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            SunkenShip: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD71': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            CoralGreen: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD72': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            CoralPurple: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD81': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            MermaidBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_REWARD82': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            MermaidRed: action.payload,
          },
        },
      };
    }

    case 'MODULE6_SET_PRIZE1': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            SandCastle: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_PRIZE2': {
      return {
        ...state,
        module6: {
          ...state.module6,
          rewards: {
            ...state.module6.rewards,
            Treasure: action.payload,
          },
        },
      };
    }

    case 'MODULE6_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module6: {
          ...state.module6,
          unlockedDays: {
            ...state.module6.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module6: {
          ...state.module6,
          unlockedDays: {
            ...state.module6.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module6: {
          ...state.module6,
          unlockedDays: {
            ...state.module6.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module6: {
          ...state.module6,
          unlockedDays: {
            ...state.module6.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module6: {
          ...state.module6,
          unlockedDays: {
            ...state.module6.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module6: {
          ...state.module6,
          unlockedDays: {
            ...state.module6.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module6: {
          ...state.module6,
          unlockedDays: {
            ...state.module6.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE6_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module6: {
          ...state.module6,
          unlockedDays: {
            ...state.module6.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }

    default:
      return state;
  }
};
export default Module6Reducer;
